import { create } from "zustand";

import { logService } from "src/core/services/logService";
import { textService } from "src/core/services/textService";
import type { Clinic } from "../../../core/backend/clients/backendClient";
import { ClinicDoctorModel } from "../models/clinicDoctorModel";
import { clinicsService } from "./clinicsService";

interface ClinicsState {
  readonly loading: boolean;
  readonly clinics: Clinic[];
  readonly clinicDoctors: ClinicDoctorModel[];

  clear: () => void;

  clinicsList: () => Promise<void>;
}

export const useClinicsStore = create<ClinicsState>()((set) => ({
  loading: false,
  clinics: [],
  clinicDoctors: [],

  clear: () => {
    set({
      loading: false,
      clinics: [],
      clinicDoctors: [],
    });
  },

  clinicsList: async () => {
    set({ loading: true });

    const response = await clinicsService.clinicsList();
    const clinics = response.clinics;

    const uniqueClinicDoctors = new Set<string>();

    const clinicDoctors =
      clinics
        ?.flatMap((clinic) =>
          clinic.doctors?.map((doctor) => ({
            clinic: clinic,
            doctor: doctor,
          }))
        )
        .filter((clinicDoctor) => {
          const uniqueKey = `${clinicDoctor?.clinic?.id}-${clinicDoctor?.doctor?.id}`;
          if (uniqueClinicDoctors.has(uniqueKey)) return false;
          else {
            uniqueClinicDoctors.add(uniqueKey);
            return true;
          }
        })
        ?.map((clinicDoctor) => {
          return new ClinicDoctorModel({
            id: (clinicDoctor?.clinic.id ?? 0) + (clinicDoctor?.doctor.id ?? 0),
            favouriteId: 0,
            clinicId: clinicDoctor?.clinic.id,
            clinicName: clinicDoctor?.clinic.name,
            clinicAddress: textService.formatAddress(
              clinicDoctor?.clinic.address
            ),
            clinicProfessionName: clinicDoctor?.clinic.professionName,
            clinicImagePath: clinicDoctor?.clinic.imagePath,
            doctorId: clinicDoctor?.doctor.id,
            doctorName: clinicDoctor?.doctor.name ?? "",
            doctorPhoneRequired: true,
            doctorImagePath: "", //clinicDoctor?.doctor.imagePath,
            profiles: clinicDoctor?.doctor.profiles ?? [],
          });
        }) ?? [];

    if (logService.globalLog) logService.log("clinicDoctors", clinicDoctors);

    set({ clinics, clinicDoctors, loading: false });
  },
}));
